import { RnUsersProfileVM } from "../../../services/rnapi2-service/models/models";

export class AccessManagementConfiguration {
  constructor(public UserProfile?: RnUsersProfileVM) {}
}
